import dynamic from 'next/dynamic';

import React, { useState, useEffect } from "react";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });

const Pagination = ({
  totalPages,
  currentPage,
  handlePageChange,
  text,
  className = "custom-class",
  activeClassName = "",
}) => {
  const [pages, setPages] = useState([]);
  const rangeStart = useEffect(() => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    setPages(pages);
  }, [totalPages]);

  return (
    <div className={className}>
      <ul className="pagination">
        <li>
          {text ? (
            <button
              className=" text-zinc-600 dark:text-zinc-300 prev-next-btn"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
          ) : (
            <button
              className="text-xl leading-4 text-zinc-900 dark:text-white h-6  w-6 flex  items-center justify-center flex-col prev-next-btn "
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <Icon icon="heroicons-outline:chevron-left" className="text-white" />
            </button>
          )}
        </li>

        {pages.map((page) => (
          <li key={page}>
            <button
              className={`${page === currentPage ? `active ${activeClassName}` : ""} page-link`}
              onClick={() => handlePageChange(page)}
              disabled={page === currentPage}
            >
              {page}
            </button>
          </li>
        ))}

        <li>
          {text ? (
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className=" text-zinc-600 dark:text-zinc-300 prev-next-btn"
            >
              Next
            </button>
          ) : (
            <button
              className="text-xl leading-4 text-zinc-900 dark:text-white  h-6  w-6 flex  items-center justify-center flex-col prev-next-btn"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <Icon icon="heroicons-outline:chevron-right" className="text-white" />
            </button>
          )}
        </li>
      </ul>
    </div>
  );
};

export default Pagination;
